import api from '@/net/repository'

export default ({ $axios }, inject) => {
    inject('api', api($axios)())
}
